/* eslint-disable no-undef */
export default class BingMaps {
    constructor() {
        this.BingMapsKey = "Auq6GMktX3ympK_7GSfeTFXe61OUvEowKJPmk8cO_SQJnzANmUOqAaY4_yFW1Uyo";
        this.map = null;
        this.infobox = null;
    }

    init() {
        this.initMap();
    }

    initMap() {
        this.map = new Microsoft.Maps.Map("#bing-maps-container", {
            credentials: this.BingMapsKey,
            showLocateMeButton: false,
            disableBirdseye: true,
            disableStreetside: true,
            allowInfoboxOverflow: true,
            disableScrollWheelZoom: true
        });

        this.infobox = new Microsoft.Maps.Infobox(this.map.getCenter(), {
            visible: false,
            maxHeight: 300,
            autoAlignment: true,
            maxwidth: 300
        });
        this.infobox.setMap(this.map);
    }

    async geocodeLocation(query, userRegion, callback) {
        const sessionId = await this.getCredentials();

        const request = `https://dev.virtualearth.net/REST/v1/Locations?q=${encodeURIComponent(query)}&userRegion=${userRegion}&incl=ciso2&key=${sessionId}`;

        try {
            const response = await fetch(request);
            const data = await response.json();
            let results;

            if (data && data.resourceSets && data.resourceSets.length > 0 && data.resourceSets[0].resources && data.resourceSets[0].resources.length > 0) {
                let country;
                if (data.resourceSets[0].resources.length === 1) {
                    country = data.resourceSets[0].resources[0].address.countryRegionIso2.toLowerCase();
                    if (country == userRegion.toLowerCase()) {
                        results = data.resourceSets[0].resources[0].address;
                    } else {
                        results = "no location found";
                    }
                } else {
                    const resources = data.resourceSets[0].resources;
                    for (const resource of resources) {
                        country = resource.address.countryRegionIso2.toLowerCase();
                        if (country == userRegion.toLowerCase()) {
                            results = resource.address;
                            break;
                        }
                    }
                }
            } else {
                results = "no location found";
            }

            if (typeof results === "undefined" || results.length === 0) {
                results = "no location found";
            }
            callback(results, userRegion);
        } catch (error) {
            callback(error.statusText, userRegion);
        }
    }

    getCredentials() {
        return new Promise((resolve) => {
            this.map.getCredentials((sessionId) => {
                resolve(sessionId);
            });
        });
    }

    clearPins() {
        this.map.entities.clear();
        this.map.setView({ zoom: 0 });
    }

    loadPins(locations) {
        const self = this;
        self.clearPins();

        const locs = [];

        if (locations.length > 0) {
            for (const location of locations) {
                var latitude = location.latitude;
                var longitude = location.longitude;

                if (typeof latitude !== "undefined" && latitude !== "") {
                    const pin = new Microsoft.Maps.Pushpin(
                        new Microsoft.Maps.Location(latitude, longitude),
                        { color: "#5261AC" }
                    );

                    pin.metadata = {
                        description: self.buildInfoBoxContent(location),
                        id: location.partnerId,
                        title: location.companyName
                    };
                    Microsoft.Maps.Events.addHandler(pin, "click", self.pushpinClicked.bind(self));

                    self.map.entities.push(pin);
                    locs.push(new Microsoft.Maps.Location(latitude, longitude));
                }
            }
            if (locs.length > 0) {
                const bounds = Microsoft.Maps.LocationRect.fromLocations(locs);
                self.map.setView({
                    bounds: bounds,
                    padding: 50
                });
            }
        }
    }

    infoBoxClick(partnerId) {
        const self = this;
        const selectedPin = self.findPin(partnerId);
        Microsoft.Maps.Events.invoke(selectedPin, "click", selectedPin);
    }

    findPin(partnerId) {
        const self = this;

        for (let i = 0; i < self.map.entities.getLength(); i++) {
            const entity = self.map.entities.get(i);
            const metadataId = entity.metadata.id;
            if (metadataId && metadataId == partnerId) {
                return entity;
            }
        }
        return null;
    }

    pushpinClicked(e) {
        if (typeof e.target === "undefined") {
            this.infobox.setOptions({
                location: e.getLocation(),
                title: e.metadata.title,
                description: e.metadata.description,
                visible: true
            });
        } else if (e.target.metadata) {
            this.infobox.setOptions({
                location: e.target.getLocation(),
                title: e.target.metadata.title,
                description: e.target.metadata.description,
                visible: true
            });
        }
    }

    buildInfoBoxContent(location) {
        let content = "";

        if (window.locationSelectionType == "ZipCodeOrState" && location.distanceText) {
            content += `<i>${location.distanceText}</i><br />`;
        }
        if (location.address1) {
            content += location.address1;
        }
        if (location.address2) {
            content += `, ${location.address2}`;
        }
        if (location.city) {
            content += `, ${location.city}`;
        }
        if (location.state) {
            content += `, ${location.state}`;
        }
        if (location.country) {
            content += `, ${location.country}`;
        }
        if (location.phone) {
            content += `<br /><a class='phone' href='tel:${location.phone}'>${location.phone}</a>`;
        }

        if (window.displayContactWebsiteLink == "True" && location.website) {
            content += `<br /><a class='partner-website-link' target='_blank' href='${location.website}'>${location.website}</a>`;
        }
        if (location.getDirectionLink) {
            const directionsLink = `https://www.bing.com/maps/directions?style=r&cp=${location.latitude}~${location.longitude}&rtp=~pos.${location.latitude}_${location.longitude}`;
            content += `<br /><a class='get-directions-link' target='_blank' href='${directionsLink}'>${window.jsl10n.JsResources.Translations.Common.GetDirections}</a>`;
        }
        return content;
    }
}